// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__1tiA3","illustration":"empty_state_illustration__2ge38","details":"empty_state_details__lblsz"};